import { render, staticRenderFns } from "./adgroupsTargetingKeyword.vue?vue&type=template&id=08087680&scoped=true&"
import script from "./adgroupsTargetingKeyword.vue?vue&type=script&lang=js&"
export * from "./adgroupsTargetingKeyword.vue?vue&type=script&lang=js&"
import style0 from "./adgroupsTargetingKeyword.vue?vue&type=style&index=0&lang=css&"
import style1 from "./adgroupsTargetingKeyword.vue?vue&type=style&index=1&id=08087680&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08087680",
  null
  
)

export default component.exports